enum SuccessConstants {
  RESEND_MOU_EMAIL_SUCCESS = 'MOU Signatory email was sent successfully.',
}

export default SuccessConstants;
